export function setBodyId(newId: string): void {
    const pageBody = document.querySelector('body');
    if (pageBody && pageBody.id !== newId) {
        pageBody.id = newId;
    }
}
